import React, { Component } from "react";

import {
  getGroupItem,
  deleteGroupItem
} from "../../../actions/other_info/group_item.action";

import { getAllTitles } from "../../../actions/other_info/title.action";
import { getAllPositions } from "../../../actions/other_info/position.action";

import Swal from "sweetalert2";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormSelect,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  FormInput
} from "shards-react";
import { Formik } from "formik";
import moment from "moment";
import { httpClient } from "../../../utils/HttpClient";
import { server } from "../../../constants";

class GroupDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ModalOpen: false,
      groupDetails: [],
      group_id: "",
      title: "",
      name: "",
      position: "",
      email: "",
      currentPage: 0,
      totalPages: 1,
      perPage: 10,
      loading: false,
      titles: [],
      positions: []
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  formatDateTime(value) {
    if (value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    }
  }

  toggleModal() {
    this.setState({
      ModalOpen: !this.state.ModalOpen,
      title: "",
      name: "",
      position: "",
      email: ""
    });
  }

  closeModal() {
    this.setState({
      ModalOpen: !this.state.ModalOpen,
      title: "",
      name: "",
      position: "",
      email: ""
    });
  }

  async addGroupNameItem(group_id, title, name, position, email) {
    var result = localStorage.getItem("user_profile");
    const displayName = JSON.parse(result).displayName;

    let dateTime = new Date();
    dateTime = moment(dateTime).format("YYYY-MM-DD HH:mm:ss");

    let formData = new FormData();

    formData.append("group_id", group_id);
    formData.append("title", title);
    formData.append("name", name);
    formData.append("position", position);
    formData.append("email", email);
    formData.append("createdAt", dateTime);
    formData.append("createdBy", displayName);

    formData.append("updatedAt", dateTime);
    formData.append("updatedBy", displayName);

    let object = {};
    formData.forEach((value, key) => {
      object[key] = value;
    });
    let json = JSON.stringify(object);

    let response = "";

    response = await httpClient.post(`${server.GROUP_ITEM_URL}`, json, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (response.status === 201 || response.status === 200) {
      Swal.fire({
        icon: "success",
        title: "ข้อมูลถูกบันทึกเรียบร้อยแล้ว",
        showConfirmButton: false,
        timer: 1500
      });

      this.setState({
        ModalOpen: false,
      });

      this.getGroupItem(this.state.currentPage);
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "เกิดข้อผิดพลาดในการบันทึกข้อมูล!",
        timer: 1500
      });
    }
  }

  async componentDidMount() {
    let groupID = this.props.match.params.id;
    await this.setState({ group_id: groupID });
    this.getGroupItem(this.state.currentPage);

    await this.props.getAllTitles();
    await this.props.getAllPositions();

    this.setState({
      titles: this.props.titlesReducer.titles,
      positions:  this.props.positionsReducer.positions
    });
  }

  async getGroupItem(page) {
    this.setState({ loading: true });

    await this.props.getGroupItem(this.state.group_id, page);

    const { groupDetails, total } = this.props.groupItemsReducer;

    const totalPages = Math.ceil(total / this.state.perPage);

    this.setState({
      groupDetails,
      totalPages,
      loading: false
    });

    this.setState({ loading: false });
  }

  renderTable = () => {
    return (
      <React.Fragment>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th className="text-center">คำนำหน้าชื่อ</th>
              <th className="text-center">ชื่อ</th>
              <th className="text-center">ตำแหน่ง</th>
              <th className="text-center">อีเมลล์</th>
              <th className="text-center">วันที่เพิ่ม</th>
              <th className="text-center">วันที่แก้ไขล่าสุด</th>
              <th className="text-center">ลบ</th>
            </tr>
          </thead>
          <tbody>
            {this.state.groupDetails.map((item, index) => {
              return (
                <tr key={item.id}>
                  <td className="text-center align-middle">{item.title}</td>
                  <td className="align-middle">{item.name}</td>
                  <td className="text-center align-middle">{item.position}</td>
                  <td className="align-middle">{item.email}</td>
                  <td className="text-center align-middle">
                    {this.formatDateTime(item.createdAt)}
                  </td>
                  <td className="text-center align-middle">
                    {this.formatDateTime(item.updatedAt)}
                  </td>
                  <td className="text-center align-middle" width="250">
                    {this.btnFormatter(item)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <Modal open={this.state.ModalOpen} toggle={this.toggleModal}>
          <ModalHeader>เพิ่ม/แก้ไข</ModalHeader>
          <ModalBody>
            <Formik
              initialValues={{
                group_id: this.state.group_id,
                title: this.state.title,
                name: this.state.name,
                position: this.state.position,
                email: this.state.email
              }}
              render={({ values, handleChange }) => (
                <React.Fragment>
                  <Row form>
                    <Col md="12" className="form-group">
                      <label>คำนำหน้าชื่อ</label>
                      <FormSelect
                        name="title"
                        id="title"
                        onChange={handleChange}
                        value={values.title}
                      >
                        <option value=""></option>
                        {this.state.titles.map(title => {
                          return (
                            <option value={title.thai_prefix} key={title.id}>
                              {title.thai_prefix}
                            </option>
                          );
                        })}
                      </FormSelect>
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>ชื่อ</label>
                      <FormInput
                        name="name"
                        id="name"
                        onChange={handleChange}
                        value={values.name}
                      />
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>ตำแหน่ง</label>
                      <FormSelect
                        name="position"
                        id="position"
                        onChange={handleChange}
                        value={values.position}
                      >
                        <option value=""></option>
                        {this.state.positions.map(position => {
                          return (
                            <option value={position.name} key={position.name}>
                              {position.name}
                            </option>
                          );
                        })}
                      </FormSelect>
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>อีเมลล์</label>
                      <FormInput
                        name="email"
                        id="email"
                        onChange={handleChange}
                        value={values.email}
                      />
                    </Col>
                  </Row>

                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-primary pull-right"
                      onClick={() => {
                        this.addGroupNameItem(
                          this.state.group_id,
                          values.title,
                          values.name,
                          values.position,
                          values.email
                        );
                      }}
                      style={{
                        marginRight: 10,
                        color: "white",
                        width: 100
                      }}
                    >
                      บันทึก
                    </button>
                    <button
                      onClick={e => this.closeModal()}
                      type="Button"
                      className="btn btn-danger pull-right"
                      style={{ color: "white", width: 100 }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                </React.Fragment>
              )}
            />
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  };

  btnFormatter(row) {
    return (
      <React.Fragment>
        <a
          onClick={() => {
            return Swal.fire({
              title: "ยืนยันการลบ?",
              text: "เมื่อลบข้อมูลแล้วจะไม่สามารถนำกลับมาได้",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it!",
              cancelButtonText: "No, cancel!"
            }).then(result => {
              if (result.value) {
                this.deleteGroupItem(row.id);
              }
            });
          }}
          type="button"
          className="btn btn-xs btn-danger text-white"
        >
          Delete
        </a>
      </React.Fragment>
    );
  }

  async deleteGroupItem(id) {
    await this.props.deleteGroupItem(id);
    setTimeout(() => {
      this.getGroupItem(this.state.currentPage);
    }, 100);
  }

  render() {
    return (
      <React.Fragment>
        <Container fluid>
          <div style={{ padding: 20 }}>
            <Card>
              <CardHeader className="border-bottom">
                <Row>
                  <Col sm="6" className="d-flex mb-2 mb-sm-0">
                    <h6 className="mt-1 text-accent">รายชื่อสมาชิกในกลุ่ม</h6>
                  </Col>
                  <Col className="text-right">
                    <Button
                      onClick={() => {
                        this.props.history.push("/group_name");
                      }}
                      type="Button"
                      className="btn btn-danger mr-2"
                    >
                      Back
                    </Button>
                    <Button
                      onClick={e => this.toggleModal()}
                      className="btn btn-secondary"
                    >
                      เพิ่มรายชื่อผู้เข้าประชุม
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody style={{ padding: "1rem" }}>
                {this.renderTable()}
              </CardBody>
            </Card>
          </div>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  groupItemsReducer,
  titlesReducer,
  positionsReducer
}) => ({
  groupItemsReducer,
  titlesReducer,
  positionsReducer
});

const mapDispatchToProps = {
  getGroupItem,
  deleteGroupItem,
  getAllTitles,
  getAllPositions
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupDetail);
